<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">

    	<span class="logo-mini text-center">
    		<router-link tag="a" class="pageLink" :to="'/'">
    			<img src="/static/img/logo_sima_100.png" alt="Logo" class="img-responsive center-block logo">
    			<span class="brand"> SIMA</span>
    		</router-link>
    	</span>

      <nav class="navbar navbar-static-top text-center" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button" id="btn-menu">
          <span></span>
        	<span></span>
        <span></span>
        </a>
        <router-link tag="a" style="position: absolute;width: 100%;left: 0;height:1px;" :to="'/'">
        <img src="/static/img/logo_sima_100.png" alt="Logo" class="img-responsive logo-mobile">
        </router-link>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <!-- User Account Menu -->
            <li class="dropdown user user-menu">
              <a href="javascript:;" @click="logout()" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fas fa-sign-out-alt"></i>
                <span>Salir</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>

    <sidebar/>

    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header" v-if="$store.state.page.title">
        <h1>
          {{ $store.state.page.title }}
        </h1>
      </section>
      <section class="content" :class="{'fullh':$route.name === 'proyecto_iframe' || $route.name === 'dashboard'}">

        <div v-if="generalAlert.show" class="alert alert-dismissible general-alert" :class="'alert-' + generalAlert.type">
          <button type="button" class="close" aria-hidden="true" @click="closeGeneralAlert()"> x </button>
          <h4 v-if="generalAlert.title"><i class="icon fa fa-ban" :class="'fa-' + generalAlert.icon"></i>{{ generalAlert.title }}</h4>
          <p v-html="generalAlert.message"></p>
        </div> 

        <router-view :key="$route.fullPath"></router-view>
      </section>
      <footer class="main-footer">
        <strong>Copyright &copy; {{year}} - v11</strong>
      </footer>       
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  //import faker from 'faker'
  import { mapState } from 'vuex'
  import config from '../config'
  import { EventBus } from '../core/event-bus.js'
  import localStorage from '../core/local-storage'
  import Sidebar from './Sidebar'
  import 'hideseek'
  import axios from "axios"
  import api from "../api"
  import db from '../core/pouchdb'
  import _ from 'lodash'

  export default {
    name: 'Template',
    components: {
    	Sidebar
    },
    data: function () {
      return {
        proyectos: [],
        year: new Date().getFullYear(),
        classes: {
          fixed_layout: config.fixedLayout,
          hide_logo: config.hideLogoOnMobile
        },
        error: '',
        estaSincronizando: false,
        onlineState: this.isNetworkOnline()
    	}
    },
    computed: {
    	...mapState([
    		'user','generalAlert'
   		])
    },
    created () {
      let vm = this
      this.$on('online', function () {
        this.onlineState = true
      })
      this.$on('offline', function () {
        this.onlineState = false
      })         
      
      EventBus.$on('enviar-email-compras', (compra, accion) => {
        vm.enviarEmails(compra, accion)
      });

      EventBus.$on('COLAPSAR MENU',() => {
        let btnMenu = document.getElementById('btn-menu')
        let body = document.getElementsByTagName('BODY')
        if (document.body.classList.contains('sidebar-open')) {
          btnMenu.click()
        }
      });
      this.interval = setInterval(() => this.isNetworkOnline(), 7000)
    },
    mounted () {
      this.getData()
    },
    destroyed () {
      EventBus.$off('enviar-email-compras')
    },    
    methods: {
        closeGeneralAlert () {
          this.$store.commit('HIDE_GENERAL_ALERT')
        },
        getData (regenerate) {
          let vm = this
          let promises = []

          if (regenerate || !this.$store.getters.hayApiDataCargada('roles')) {
            promises.push(api.getRoles())
          }

          if (regenerate || !this.$store.getters.hayApiDataCargada('proyectos')) {
            promises.push(vm.getProyectos())
          }

          Promise.all(promises).then(values => {
            this.$store.commit('DATA_LOADED')
            EventBus.$emit('datos-cargados');
          },(error) => {
            EventBus.$emit('error-carga');
          })        
        },
        getProyectos() {
          let vm = this
          return api.getProyectos().then(data => {
            let _keys = []
            let _data = []
            
            vm.$store.commit('CLEAR_API_DATA', 'proyectos')
            
            data.forEach(item => {
              if (item['Activo']) {
                _data.push(item)
                _keys.push(item.codigo_proyecto) 
              }
            })

            vm.$store.commit('SYNC_API_DATA', {
              type: 'proyectos',
              items: _data
            })

            vm.$store.commit('SYNC_API_DATA', {
              type: 'proyectos_keys',
              items: _keys
            })

            return _data
          })
        },
        isNetworkOnline() {
          let vm = this
          axios.get('https://images.sima-api.com/image-handler/img/sima-api/favicon-16x16.png?timestamp=' + new Date().getTime())
            .then(function (response) {
              vm.$store.commit('SYNC_ONLINE', true)
              if (!vm.estaSincronizando) {
                vm.syncAPI()
              }
            }).catch(function (error) {
              vm.$store.commit('SYNC_ONLINE', false)
            })
        },    
        syncAPI () {
          let vm = this
          let _api = []
          let toast = null

          _api['parte_diario'] = '/simaappformpartediarios'
          _api['reporte_media'] = '/simaappreportes'
          _api['compras'] = '/simaappcompras'

          db.getAllToSync().then((response) => {
            if (response.docs.length > 0 ) {
              let promises = []

              vm.estaSincronizando = true
              vm.$toasted.show("Sincronizando datos. Por favor espere.", { 
                icon : 'sync',
                theme: "primary", 
                position: "top-center"
              })

              for (let i = 0; i < response.docs.length; i++) {
                
                let id = response.docs[i]._id.toString()
                let asset = response.docs[i].asset.toString()
                switch (response.docs[i].action) {
                  case 'create':
                    promises.push(vm.addAPI(response.docs[i], _api).then((resp) => {
                      if (response.docs[i].asset === 'compras' && typeof response.docs[i].accion_email !== 'undefined') {
                        let accion = _.clone(response.docs[i].accion_email)
                        delete response.docs[i].accion_email
                        vm.enviarEmails(response.docs[i], accion)
                      }
                      vm.removeFromLocalDB(id)
                    }))
                    break
                  case 'edit':
                    promises.push(vm.editAPI(response.docs[i], _api).then(() => {
                      if (response.docs[i].asset === 'compras' && typeof response.docs[i].accion_email !== 'undefined') {
                        let accion = _.clone(response.docs[i].accion_email)
                        delete response.docs[i].accion_email
                        vm.enviarEmails(response.docs[i], accion)
                      }                      
                      vm.removeFromLocalDB(id)
                    }))
                    break
                }
              }
              if (promises.length > 0) {
                Promise.all(promises).then((values) => {
                  EventBus.$emit('sync-completed');
                  vm.estaSincronizando = false
                  vm.$toasted.clear()
                })
              } else {
                vm.estaSincronizando = false
                vm.$toasted.clear()
              }

            } else {
              vm.estaSincronizando = false
            }
          })

        },
        addAPI (item, _api) {
          let tipo = item.asset

          delete item._id
          // delete item.asset
          
          return api.request('POST', _api[tipo], item, true)
        },
        editAPI (item, _api) {
          let id = item._id
          let tipo = item.asset
          
          delete item._id;
          // delete item.asset;

          return api.request('PUT', _api[tipo] + '/' + id, item, true)
        },
        removeFromLocalDB (id) {
          db.getById(id).then((doc) => {
            return db.remove(doc)
          }).catch((error) => {
            alert('Error en removeFromLocalDB: ' + error)
          })
        },
        changeloading () {
          this.$store.commit('TOGGLE_SEARCHING')
        },
        enviarEmails (compra, accion) {
          let vm = this
          let to = []
          let cc = []

          let usuariosPorRoles = vm.getUsuariosPorRoles(compra.codigo_proyecto)
          let mensajes = this.$store.state.jsonStatic.compras.mensajes
          let subjects = this.$store.state.jsonStatic.compras.subjects 

          switch (accion) {
            case 'Pendiente':
              to = vm.getEmailsPorRoles(usuariosPorRoles, ['manager'])
              cc = vm.getEmailsPorRoles(usuariosPorRoles, ['jefe_de_obras', 'coordinador'])
              break
            case 'Aprobado':
              to = vm.getEmailsPorRoles(usuariosPorRoles, ['compras'])
              // cc = vm.getEmailsPorRoles(usuariosPorRoles, ['jefe_de_obras', 'coordinador'])
              break
            case 'Rechazado':
              to = vm.getEmailsPorRoles(usuariosPorRoles, ['manager'])
              cc = vm.getEmailsPorRoles(usuariosPorRoles, ['supervisor', 'empleado', 'jefe_de_obras', 'coordinador'])
              break
            case 'Comprado':
              to = vm.getEmailsPorRoles(usuariosPorRoles, ['manager'])
              cc = vm.getEmailsPorRoles(usuariosPorRoles, ['supervisor', 'empleado', 'jefe_de_obras', 'coordinador'])
              break
            case 'Completado':
              to = vm.getEmailsPorRoles(usuariosPorRoles, ['compras'])
              cc = vm.getEmailsPorRoles(usuariosPorRoles, ['jefe_de_obras', 'coordinador', 'manager'])
              break
          }

          let subject = '[{codigo_proyecto}] {pedido_id} - {subject_estado}'
          let mensaje = mensajes[accion] + '\n\n' +
                        'Detalle del Pedido: \n\n' +
                        '- # Pedido: {pedido_id} \n' +
                        '- Proyecto: {codigo_proyecto} \n' +
                        '- Estado: {estado} \n' +
                        '- Item: {item_descripcion} - {qty} {unidad_medida} \n' +
                        '- Solicitado por: {solicitado_user} \n' +
                        '- Validado por: {validado_user} \n' +
                        '- Comprado por: {comprado_user} \n' +
                        '- # Orden de Compra: {id_orden_compra}'

          mensaje = mensaje.replace('{pedido_id}', compra.pedido_id)
                            .replace('{codigo_proyecto}', compra.codigo_proyecto)
                            .replace('{estado}', compra.estado)
                            .replace('{item_descripcion}', (compra.item_descripcion ? compra.item_descripcion : ''))
                            .replace('{qty}', (compra.qty ? compra.qty : ''))
                            .replace('{unidad_medida}', (compra.unidad_medida ? compra.unidad_medida : ''))
                            .replace('{solicitado_user}', (compra.solicitado_user ? compra.solicitado_user : ''))
                            .replace('{validado_user}', (compra.validado_user ? compra.validado_user : ''))
                            .replace('{comprado_user}', (compra.comprado_user ? compra.comprado_user : ''))
                            .replace('{id_orden_compra}', (compra.id_orden_compra ? compra.id_orden_compra : ''))

          subject = subject.replace('{codigo_proyecto}', compra.codigo_proyecto)
                            .replace('{pedido_id}', compra.pedido_id)
                            .replace('{subject_estado}',  subjects[accion])

          console.debug(mensaje)

          if (to.length > 0) {
            api.enviarEmail({
              'toEmailAddresses': to,
              'ccEmailAddresses': cc,
              'bodyData': mensaje,
              'subjectdata': subject
            }).then(resp => {
              console.debug(resp)
            })
          }
        },
        getUsuariosPorRoles (codigoProyecto) {
          let vm = this
          let proyecto = vm.$store.getters.getProyectoPorCodigo(codigoProyecto)
          let salida = {}

          if (proyecto) {
            for (let i = 0; i < proyecto.usuarios.length; i++) {
              let usuario = proyecto.usuarios[i]
              if (usuario.email) {
                let tipoRol = vm.$store.getters.getTipoRolPorCodigo(usuario.role)
                if (typeof salida[tipoRol] === 'undefined') {
                  salida[tipoRol] = []
                }
                salida[tipoRol].push(usuario)
              }
            }
          }

          return salida
        },
        getEmailsPorRoles (usuarios, roles) {
          let salida = []

          for (let i = 0; i < roles.length; i++) {
            if (typeof usuarios[roles[i]] !== 'undefined') {
              for (let j = 0; j < usuarios[roles[i]].length; j++) {
                salida.push(usuarios[roles[i]][j].email)
              }
            }
          }

          return salida
        },
        logout () {
            this.$store.commit('SET_USER', null)
            this.$store.commit('SET_TOKEN', null)
            localStorage.removeUser()
            localStorage.removeToken()
            document.body.classList.remove('sidebar-open')
            this.$router.push('/login')
        }   	
    }
  }
  window.addEventListener("beforeunload", confirm);
  function confirm(e) {
    var confirmationMessage = "Se perderán los datos no sincronizados. ¿Desea continuar?";     
    e.returnValue = confirmationMessage;           
    return confirmationMessage;       
  } 
</script>
<style>
.logo-mobile {
  display: none;
}
.v-bounce {
  margin-right: auto;
  margin-left: auto;
}
.wrapper.fixed_layout .main-header {
	position: fixed;
	width: 100%;
}

.wrapper.fixed_layout .content-wrapper {
	padding-top: 50px;
	min-height: 850px;
}
html, body, #app {
  overflow-y: none!important;
}
html, body,.wrapper,.content-wrapper .content,.container-fluid{
	min-height: 100%;
  height: 100%;
}
.content-wrapper{
  min-height: 100%;
  height: 100%;
  position: relative;
}
.content {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  padding-bottom: 30%;
  /* position: relative; */
}
.content.fullh {
  padding-bottom: 5%!important;
}
.control-sidebar {
  height: 100%;
  overflow-y: auto;

  padding-bottom: 10%;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.control-sidebar.control-sidebar-open{
  min-width: 30%;  
}

.wrapper.fixed_layout .main-sidebar {
	position: fixed;
	height: 100vh;
}

.brand {
	color: #fff;
	float: left;
	font-size: 20px;
	margin-top: 11px;
}

.skin-red .main-header .logo {
	width: 50px;
}
.sidebar-collapse .main-header .navbar .sidebar-toggle{
    margin-left: -40px;
}

.main-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -15px;
}

@media ( max-width : 767px) {
	.wrapper.hide_logo .main-header .logo {
		display: none;
	}
  .logo-mobile {
    display: inline-block;
  }
  .logo-mobile{
    max-width: 40px;
    margin-top: 5px;
  }  
  .main-header .navbar {
      margin: 0;
      text-align: center;
  }  
  .logo-mini {
    display: none;
  }

}

.logo {
	max-width: 50px;
}

.logo-mini, .logo-lg {
	text-align: center;
}

.logo-mini img, .logo-lg img {
	padding: 0.4em !important;
}

.logo-lg img {
	display: -webkit-inline-box;
	width: 25%;
}

.user-panel {
	height: 4em;
}

hr.visible-xs-block {
	width: 100%;
	background-color: rgba(0, 0, 0, 0.17);
	height: 1px;
	border-color: transparent;
}

.sidebar-toggle span {
	display: block;
	width: 20px;
	height: 3px;
	margin-bottom: 4px;
	position: relative;
	background: #fff;
	border-radius: 3px;
	z-index: 1;
	transform-origin: 4px 0px;
	transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0),
		background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0), opacity 0.55s ease;
}

.sidebar-toggle span:first-child {
	transform-origin: 0% 0%;
}

.sidebar-toggle span:nth-last-child(2) {
	transform-origin: 0% 100%;
}

.main-header .sidebar-toggle:before {
	content: "";
}

.table-responsive {
  width: 100%;
}

.vdp-datepicker {
  color: #333;
}
.vdp-datepicker input{
  background-color: #fff!important;
}
.vdp-datepicker input[disabled] {
  background-color: #eee!important;  
}
.general-alert {
  margin: 10px;
}
.modal-slideshow__container__image {
  background-color: transparent!important;
}
.modal-slideshow{
  background-color: rgba(0, 0, 0, 0.85)!important;
}
@media (max-width: 768px) {
  .modal-slideshow {
    position: fixed!important;
    top: 45px!important;
  }
  .modal-slideshow__close {
    top: 5px!important;
    right: 10px!important;    
  }
  .modal-slideshow__next {
      right: 10px!important;
  }  
  .modal-slideshow__prev, .modal-slideshow__next {
    font-size: 50px!important;
  }
  .modal-slideshow__close {
    font-size: 40px!important;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Template.vue